import { Alert, Box, Button } from '@mui/material';
import CpdSectionHeader from '@/components/ui/CpdSectionHeader';
import FormErrorSummary from '@/components/FormErrorSummary/FormErrorSummary';
import loader from '@/assets/img/loader.svg';
import useOAuthCredentialForm from './useOAuthCredentialForm';
import OAuthCredentialFields from './OAuthCredentialFields';
import OAuthCredentialActions from './OAuthCredentialActions';

const NO_SETTINGS_FIELDS = [];

const OAuthCredentialForm = ({
  title,
  providerName,
  readOnlyMessage,
  data,
  loading,
  loadError = null,
  onRetry,
  saving,
  testing = false,
  testResult = null,
  onSave,
  onTest,
  settingsFields = NO_SETTINGS_FIELDS,
  showTokenUrl = false,
  scopeOptions,
}) => {
  const credentialForm = useOAuthCredentialForm({
    data,
    settingsFields,
    showTokenUrl,
    scopeOptions,
    onSave,
  });

  if (loading) {
    return (
      <div className='loaders' style={{ marginTop: '20px' }}>
        <img alt='loader' src={loader} />
      </div>
    );
  }

  const header = <CpdSectionHeader title={title} />;

  if (loadError) {
    return (
      <Box>
        {header}
        <Alert
          severity='error'
          action={
            <Button color='inherit' size='small' onClick={onRetry}>
              Retry
            </Button>
          }>
          Failed to load the {providerName} API credential.
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      {header}

      <FormErrorSummary errors={credentialForm.generalErrors} />
      {credentialForm.readOnly && (
        <Alert severity='info' sx={{ mb: 2 }}>
          {readOnlyMessage}
        </Alert>
      )}

      <OAuthCredentialFields
        form={credentialForm.form}
        fieldErrors={credentialForm.fieldErrors}
        disabled={credentialForm.readOnly || saving}
        hasClientSecret={credentialForm.hasClientSecret}
        settingsFields={settingsFields}
        showTokenUrl={showTokenUrl}
        scopeOptions={scopeOptions}
        availableScopes={credentialForm.availableScopes}
        onFieldChange={credentialForm.changeField}
        onSettingChange={credentialForm.changeSetting}
      />

      <OAuthCredentialActions
        providerName={providerName}
        testResult={testResult}
        saving={saving}
        testing={testing}
        readOnly={credentialForm.readOnly}
        hasCredential={credentialForm.hasCredential}
        canTest={Boolean(onTest)}
        onSave={credentialForm.save}
        onTest={onTest}
      />
    </Box>
  );
};

export default OAuthCredentialForm;
